//Common
import { DataGrid, Drawer } from "../../common/VFX-UI";
import { MoreActionButton } from "../../common/Buttons";
import PageHeader from "../../common/PageHeader/PageHeader";
import { MoreActionsMenu } from "../../common/MoreActionsMenu";

//App
import { ColumnDescription } from "react-bootstrap-table-next";
import useComponentGeneralStyles from "../../styles";
import { TemplateEmailProps } from "../../../types/template";
import useTemplate from "./hooks/useTemplate";
import TemplateEmailView from "./TemplateEmailView";
import { TemplateEmailFormContainer } from "./TemplateEmailFormContainer";
import SearchContainer from "../../common/Forms/SearchContainer/SearchContainer";


const TemplateEmail: React.FC<TemplateEmailProps> = (props) => {
  const {
    data: templates,
    fullscreen,
  } = props;
  const generalStyles = useComponentGeneralStyles();

  const {
    state,
    formContext,
    rowEvents,
    actionColumnAnchorEl,
    toggleNewViewHandler,
    toggleViewHandler,
    toggleEditViewHandler,
    toggleDeactivateHandler,
    toggleActivateHandler,
    onShowSuccess,
    handleActionClick,
    setActionColumnAnchorEl,
  } = useTemplate({deleteMutation: function (): void {},});

  const openMenu = Boolean(actionColumnAnchorEl);


  var columns: ColumnDescription[] = [
    {
      dataField: "id",
      text: "ID",
      hidden: true,
    },
  ];

  if (fullscreen === null || fullscreen === undefined || fullscreen) {
    columns = [
      ...columns,
      {
        dataField: "templateName",
        text: "Name",
        sort: false,
      },
      {
        dataField: "templateDescription",
        text: "Description",
        sort: false,
      },
      {
        dataField: "subject",
        text: "Subject",
        sort: false,
      },
      {
        dataField: "fromEmailAddress",
        text: "From",
        sort: false,
      },
    ];
  } else {
    columns = [
      ...columns,
      {
        dataField: "templateName",
        text: "Name",
        sort: false,
      },
      {
        dataField: "templateDescription",
        text: "Description",
        sort: false,
      },
      {
        dataField: "subject",
        text: "Subject",
        sort: false,
      },
      {
        dataField: "fromEmailAddress",
        text: "From",
        sort: false,
      },
    ];
  }

  columns = [
    ...columns,
    {
      dataField: "action",
      text: "",
      style: { width: "25px" },
      isDummyField: true,
      formatter: () => {
        return (
          <MoreActionButton handleActionClick={(e) => handleActionClick(e)} />
        );
      },
    },
  ];

  return (
    <>
      <PageHeader>Email Templates</PageHeader>
      <div style={generalStyles.searchContainer}>
        <SearchContainer
            toggleNewViewHandler={toggleNewViewHandler}
            newButtonStyle={{ height: "100%" }}
          />
      </div>

      <Drawer show={state.toggleNewForm}>
        {state.toggleNewForm && (
          <TemplateEmailFormContainer
            onClose={toggleNewViewHandler}
            onShowSuccess={onShowSuccess}
          />
        )}
      </Drawer>

      <Drawer show={state.toggleEditForm}>
        {state.toggleEditForm && formContext?.data && (
          <TemplateEmailFormContainer
            onClose={toggleEditViewHandler}
            onShowSuccess={onShowSuccess}
          />
        )}
      </Drawer>

      <Drawer show={state.toggleView}>
        {state.toggleView && formContext?.data && (
          <TemplateEmailView
            onClose={toggleViewHandler}
            editAction={() => {
              toggleEditViewHandler();
            }}
            toggleDeactivateHandler={toggleDeactivateHandler}
            toggleActivateHandler={toggleActivateHandler}
          />
        )}
      </Drawer>

      <DataGrid
        columns={columns}
        data={templates}
        keyField="id"
        rowEvents={rowEvents}
        remote={true}
      />

      {actionColumnAnchorEl && (
        <MoreActionsMenu
          isOpen={openMenu}
          target={actionColumnAnchorEl}
          toggle={() => {
            setActionColumnAnchorEl(null);
          }}
          onViewClick={() => {
            toggleViewHandler();
            setActionColumnAnchorEl(null);
          }}
        />
      )}
    </>
  );
};

export default TemplateEmail;
